import { useRef } from "react";
import ReactECharts from "echarts-for-react";
import { EChartOption, graphic } from "echarts";
import { QuoQuestLevelStage } from "../types/quest";
import { useSwiperSlide } from "swiper/react";
import Crown from "../assets/graphics/crown.png";

type QuoQuestLevelChartProps = Pick<
  QuoQuestLevelStage,
  "graph" | "hasCleared" | "marketDateFrom" | "marketDateTo"
> & { level: number };

const QuoQuestLevelChart = ({
  graph,
  hasCleared,
  marketDateFrom,
  marketDateTo,
  level
}: QuoQuestLevelChartProps) => {
  const swiperSlide = useSwiperSlide();
  const levelBgColor =
    level < 6 ? "bg-[#00E1FF]" : level < 11 ? "bg-[#0AF892]" : "bg-[#F4F80B]";
  const chartRef = useRef<any>(null);

  const option: EChartOption = {
    grid: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    xAxis: {
      type: "time",
      show: false
    },
    yAxis: {
      type: "value",
      show: false
    },
    series: [
      {
        name: "Training Data",
        type: "line",
        smooth: false,
        symbol: "none",
        lineStyle: {
          color: "#8971FF"
        },
        areaStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "#8971FF"
            },
            {
              offset: 1,
              color: "#8971FF00"
            }
          ])
        },
        data: graph
          .filter(entry => entry.date <= marketDateFrom)
          .map(entry => [+entry.date, entry.value])
      },
      {
        name: "Training Data 2",
        type: "line",
        smooth: false,
        symbol: "none",
        lineStyle: {
          color: "#00E1FF"
        },
        areaStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "#00E1FF"
            },
            {
              offset: 1,
              color: "#00E1FF00"
            }
          ])
        },
        data: graph
          .filter(
            entry => entry.date >= marketDateFrom && entry.date <= marketDateTo
          )
          .map(entry => [+entry.date, entry.value])
      },
      {
        name: "Training Data 3",
        type: "line",
        smooth: false,
        symbol: "none",
        lineStyle: {
          color: "#8971FF"
        },
        areaStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "#8971FF"
            },
            {
              offset: 1,
              color: "#8971FF00"
            }
          ])
        },
        data: graph
          .filter(entry => entry.date >= marketDateTo)
          .map(entry => [+entry.date, entry.value])
      }
    ]
  };
  return (
    <div className="w-full h-full relative">
      <ReactECharts
        option={option}
        notMerge={true}
        lazyUpdate={true}
        className="w-full h-full"
        ref={chartRef}
        onChartReady={instance => {
          const screenWidth = window.innerWidth;
          instance.resize({ width: screenWidth });
        }}
      />
      <div
        className={`absolute left-1/2 top-1/2 -translate-x-1/2 ${
          swiperSlide.isActive && hasCleared
            ? "-translate-y-1/2 opacity-100"
            : "translate-y-36 opacity-0"
        } flex transition-all duration-1000 w-12 h-12 p-1 ${levelBgColor} rounded-md items-center justify-center`}
      >
        <img src={Crown} alt="Quest Level Crown" className="mr-2 max-h-8" />
      </div>
    </div>
  );
};

export default QuoQuestLevelChart;
